import React from "react";

const SwitchDisplay = ({switchTab, listTabColor, blockTabColor, tableTabColor, listLayoutOnlyFor, blockLayoutOnlyFor, tableLayoutOnlyFor}) => (
  <div className={`row justify-content-end position-relative m-0 d-none d-md-flex ${!tableTabColor && 'mr-70px-imp'}`}>
      {
        tableTabColor &&
          <i onClick={switchTab}
             id="button-table"
             style={{cursor: 'pointer', right: '0'}}
             className={`rounded m-0 fas fa-align-justify text--size-title p-2 btn-change-view-position mr-10px-imp ${tableTabColor} ${ tableLayoutOnlyFor}`}
          />
      }

    {
      listTabColor &&
        <i onClick={switchTab}
           id="button-list"
           style={{cursor: 'pointer'}}
           className={`rounded m-0 fas fa-list text--size-title p-2 btn-change-view-position right-80px desktop-right-list-icon mr-10px-imp ml-10px-imp ${listTabColor} ${listLayoutOnlyFor}`}
        />
    }

    {
      blockTabColor &&
        <i onClick={switchTab}
           id="button-block"
           style={{cursor: 'pointer'}}
           className={`rounded m-0 fa fa-th text--size-title p-2 btn-change-view-position ml-10px-imp ${blockTabColor} ${blockLayoutOnlyFor}`}
        />
    }
  </div>
);

export default SwitchDisplay;